function MoviePoster({ src, alt }) {
    return (
      <div
        className="rounded-lg overflow-hidden border-2 border-white p-2"
        style={{ height: "250px" }}
      >
        {src ? (
          <img src={src} alt={alt} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-500">
            {alt}
          </div>
        )}
      </div>
    );
  }

  export default MoviePoster;